import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useDispatch} from 'react-redux';
import Modal from '../../Modal/Modal';
import Loader from '../../LoadingIndicator/LoadingIndicator';
import styled from 'styled-components';
import RisksItem from './src/RisksItem';
import {clearNewRisk, createNewRisk} from '../../../../actions/Risk/riskactions';
import {useOverrideLabels} from '../../../Main/Forms/Utilities/OverrideLabelsProvider';
import {updateRiskFactorRelation} from '../../../../actions/RiskFactor/riskfactoractions';
import {clientSideEventNames} from '../../../../util/uiconstants';

export default function RiskModal(props) {
	const {
		riskType,
		show,
		onClose,
		engagementId,
		headerId,
		riskFactorId,
		riskFactorRelationId,
		documentId,
		onSaveSuccess
	} = props;
	const dispatch = useDispatch();
	const [risk, setRisk] = useState({});
	const [newRisk, setNewRisk] = useState({});
	const [isLoading, setIsLoading] = useState(false);
	const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true);

	const {labels} = useOverrideLabels();

	const updateRiskFactorRelationCall = async (updatedRelation) => {
		dispatch(
			updateRiskFactorRelation(Number(engagementId), headerId, riskFactorRelationId, riskFactorId, updatedRelation)
		);
		dispatch(clearNewRisk());
	};

	useEffect(() => {
		if (Object.keys(newRisk).length > 0) {
			const riskFactorRelation = {
				op: 'replace',
				path: '/riskId',
				value: newRisk.id
			};

			const riskFactorRelationIsNotMaterial = {
				op: 'replace',
				path: '/isNotMaterial',
				value: false
			};

			const riskFactorRelationDocumentId = {
				op: 'replace',
				path: '/documentId',
				value: documentId
			};

			const updatedRelation = [riskFactorRelation, riskFactorRelationIsNotMaterial, riskFactorRelationDocumentId];

			updateRiskFactorRelationCall(updatedRelation)
				.then(() => {
					setIsLoading(false);
				})
				.finally(() => {
					setIsLoading(false);
					onClose && onClose();
				});
		}
	}, [newRisk]);

	const handlerOnItemChange = (risk) => {
		if (risk && risk.riskName && risk.riskName.length > 0) {
			setIsSaveButtonDisabled(false);
		} else {
			setIsSaveButtonDisabled(true);
		}
		setRisk(risk);
	};

	const onSaveChangesHandler = () => {
		setIsSaveButtonDisabled(true);
		setIsLoading(true);
		dispatch(createNewRisk(engagementId, risk, {}))
			.then((response) => {
				setNewRisk(response);
				onSaveSuccess && onSaveSuccess();
			})
			.catch(() => {})
			.finally(() => {
				setIsLoading(false);
				setIsSaveButtonDisabled(false);
			});
	};

	const buildModalChildren = () => {
		return (
			<>
				<Loader show={isLoading} styleName={'inFrontView'} />
				<StyledNewRisksModalBody className="StyledNewRisksModalBody">
					<ul>
						<RisksItem onItemChange={handlerOnItemChange} showRiskTypeLabel riskType={riskType} />
					</ul>
				</StyledNewRisksModalBody>
			</>
		);
	};

	return (
		<Modal
			show={show}
			title={labels.addNewRiskModalTitle}
			closeTitle={labels.modalCloseTitle}
			modalsize={'small'}
			showButtons
			confirmBtnTitle={labels.modalConfirmButton}
			closeBtnTitle={labels.modalCancelTitle}
			onOkClick={onSaveChangesHandler}
			isOkButtonDisabled={isSaveButtonDisabled}
			onHide={() => onClose && onClose()}
			modalContainerClass={'newrisk-modal'}
			isAresView
		>
			{buildModalChildren()}
		</Modal>
	);
}

RiskModal.propTypes = {
	show: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired
};

const StyledNewRisksModalBody = styled.section`
	padding: 0;
	ul li {
		margin-bottom: var(--px-20);
	}
`;
